import React from "react";
import { Link } from "react-router-dom";

const DeleteAccountInfo = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white dark:bg-gray-900 dark:text-gray-100 shadow-md rounded-lg mt-8">
      <h1 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4">
        Delete My Account – Keyway App
      </h1>

      <p className="mb-4">
        If you want to delete your Keyway App account (powered by Business
        Yield), follow these steps:
      </p>

      <ol className="list-decimal list-inside mb-6 space-y-2">
        <li>Click on the profile at the bottom menu</li>
        <li>
          Scroll to the bottom and click <strong>Delete my account</strong>
        </li>
        <li>
          Confirm your deletion a request will be made to our server to delete
          the account.
        </li>
      </ol>

      <p className="mb-4">
        If the option to delete your account is unavailable, please contact our{" "}
        <Link
          to={"/explore/delete-account"}
          className="text-blue-600 dark:text-blue-400 underline"
        >
          Online Delete Request
        </Link>
        .
      </p>

      <p className="mb-4 text-red-500 dark:text-red-400 font-medium">
        Deleting your account is permanent and cannot be undone. This includes:
      </p>

      <ul className="list-disc list-inside mb-6 space-y-1">
        <li>Any promotions or discount history</li>
        <li>Your Preferences</li>
        <li>Your Active Subscription</li>
      </ul>

      {/* <div className="p-4 bg-yellow-50 dark:bg-yellow-900 border border-yellow-300 dark:border-yellow-600 rounded text-yellow-800 dark:text-yellow-100">
        <strong>Note:</strong> This feature is being rolled out gradually. If
        you don’t see the delete option in your app, please contact support to
        request account deletion manually.
      </div> */}
    </div>
  );
};

export default DeleteAccountInfo;
